module.exports = __webpack_public_path__ + "img/logo.ae26e553.svg";